require('./bundle-manifest').register(JSON.parse("{\"6uhNn\":\"index.a377d02e.js\",\"51idw\":\"img.cbcfd67a.png\",\"1Pbqg\":\"index.6ad4c631.css\"}"));